export default __webpack_public_path__ + "static/media/logo_bsibility.414a0cfc.png";